function NavBarSpicy() {
  return (
    <svg
      width={565}
      height={54}
      viewBox="0 0 565 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M563.123 52.8784L563.123 28.0423L564.123 28.0423L564.123 53.9583L563.123 53.9583L563.123 53.8784L516.123 53.8784L516.123 52.8784L563.123 52.8784ZM163 52.8784L325 52.8784L325 53.8784L163 53.8784L163 52.8784Z"
        fill="#22222F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.12299 52.9929L1.12299 42.0799L0.122986 42.0799L0.122986 53.9581L0.683891 53.9581L0.683891 53.9929L49.4212 53.9929L49.4212 52.9929L1.12299 52.9929Z"
        fill="#22222F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M300 1.04639H486V0.0463867H300V1.04639ZM76.123 1.32373L15.123 1.32373V0.323726L76.123 0.323732V1.32373ZM1.12299 14.2817L1.12299 26.1598H0.122986V14.2817H1.12299Z"
        fill="#22222F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.35 0.760647L0.677669 15.3616L0.0285034 14.6009L14.7008 0L15.35 0.760647Z"
        fill="#22222F"
      />
    </svg>

  );
}

export default NavBarSpicy;